<template>
  <transition-group
    tag="ul"
    id="drop-zone"
    class="flex flex-col transition-all duration-500"
    name="list"
    leave-active-class="animate__animated animate__fadeOutRight"
    enter-active-class="animate__animated animate__fadeInUp"
    @drop="onDrop"
    @dragover.prevent="getItemPosition($event.clientY)"
    @dragenter.prevent
    @dragleave.prevent
  >
    <Task
      :key="task.id"
      v-for="task in tasks"
      :task="task"
      @delete-task="$emit('delete-task', task.id)"
      @change-status="$emit('change-status', task.id)"
      @dragstart="startDrag($event, task)"
      draggable="true"
    />
  </transition-group>
</template>
<script>
import Task from "./Task";
export default {
  name: "Tasks",
  props: {
    tasks: Array,
  },
  data() {
    return { selectedItem: {}, selectedItemPosition: 0 };
  },
  components: {
    Task,
  },
  methods: {
    startDrag(event, task) {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("taskID", task.id);
      this.selectedItem = document.getElementById("task-" + task.id);
      const dropZone = document.getElementById("drop-zone");
      setTimeout(() => {
        dropZone.removeChild(this.selectedItem);
      }, 0);
    },
    resetListItems() {
      let listItems = document.querySelectorAll(".draggable-item");
      for (let i = 0; i < listItems.length; i++) {
        document.getElementById(listItems[i]["id"]).classList.remove("mt-12");
        document
          .getElementById(listItems[i]["id"])
          .classList.remove("transition-all");
        document
          .getElementById(listItems[i]["id"])
          .classList.remove("duration-300");
      }
    },
    getItemPosition(currentYPosition) {
      let listItems = document.querySelectorAll(".draggable-item");
      let itemAbove;
      let ItemBelow;
      for (let i = 0; i < listItems.length; i++) {
        let itemPosition = listItems[i].getBoundingClientRect();
        let topPosition = itemPosition.top;
        let bottomPosition = itemPosition.bottom;
        listItems[i]["yPosition"] =
          topPosition + (bottomPosition - topPosition) / 2;
        if (listItems[i]["yPosition"] < currentYPosition) {
          itemAbove = document.getElementById(listItems[i]["id"]);
          this.selectedItemPosition = i + 1;
        } else {
          if (!ItemBelow) {
            ItemBelow = document.getElementById(listItems[i]["id"]);
          }
        }
      }
      if (typeof itemAbove == "undefined") {
        this.selectedItemPosition = 0;
      }
      this.resetListItems();
      if (typeof ItemBelow == "object") {
        ItemBelow.classList.add("transition-all");
        ItemBelow.classList.add("mt-12");
      }
    },
    onDrop() {
      const dropZone = document.getElementById("drop-zone");
      this.resetListItems();
      dropZone.insertBefore(
        this.selectedItem,
        dropZone.children[this.selectedItemPosition]
      );
      const droppables = dropZone.children;
      const taskList = [];
      for (let i = 0; i < droppables.length; i++) {
        taskList.push({
          id: i + 1,
          done: droppables[i].childNodes[0].firstElementChild.checked,
          description: droppables[i].childNodes[1].innerText,
        });
      }
      this.$emit("save-new-task-order", taskList);
    },
  },
  emits: ["delete-task", "change-status", "save-new-task-order"],
};
</script>
